module.exports = __webpack_public_path__ + "img/Rhonda_Morris@3x.21eb1a01.webp";